import FilterMenu from "./filtermenu.js";
import FilterValues from "./filtervalues.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const timerInterval = 500;
const productionTime = document.getElementById('productionTimeContent');
const imprintLocationCount = document.getElementById('imprintLocationCountContent');
const imprintColorCount = document.getElementById('imprintColorCountContent');
const mobileFilterDropDown = document.getElementById('filterDropDown');
let productionTimer;
let locationTimer;
let colorTimer;

class RadioButtonFilter {
    /**
     * Sets up event listeners for the radio button filters.
     * @return {void}
     */
    events() {
        productionTime && productionTime.querySelectorAll('input[type=radio]').forEach(el => {
            el.addEventListener('change', () => {
                clearTimeout(productionTimer);
                productionTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });

        imprintLocationCount && imprintLocationCount.querySelectorAll('input[type=radio]').forEach(el => {
            el.addEventListener('change', () => {
                clearTimeout(locationTimer);
                locationTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });

        imprintColorCount && imprintColorCount.querySelectorAll('input[type=radio]').forEach(el => {
            el.addEventListener('change', () => {
                clearTimeout(colorTimer);
                colorTimer = setTimeout(() => this.action(el), timerInterval);
            });
        });
    };

    /**
     * Handles the action when a radio button filter is changed.
     * @param {HTMLElement} element The radio button element that was changed.
     * @return {void}
     */
    action(element) {
        // clear out any existing filters previously selected
        const id = element.id.slice(0, element.id.lastIndexOf('_') + 1);
        SelectedFilters.selectedFilterList.querySelectorAll('div[class*="' + id + '"]').forEach(el => {
            let index = el.classList.value.indexOf(id) + id.length;
            FilterMenu.markUnSelected(document.getElementById(id + el.classList.value.slice(index).split(/\s/)[0]));
        });

        FilterMenu.markSelected(element);

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);
    };
}

export default new RadioButtonFilter();